import { LinksBox } from './component.styles'
export default LinksBox
